import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class Loading extends Component {
  render () {
    const {
      className,
      isLoading,
      image
    } = this.props

    return (
      <div className={className + (isLoading ? ' isloading' : '')}>
        <div className="message">
          {image &&
            <img src={image} alt='loading image'/>
          }
          {!image &&
            <div className="notice">
              <p>Nattofranco</p>
              <p>Loading...</p>
            </div>
          }
        </div>
      </div>
    )
  }
}

Loading.defaultProps = {
  className: 'loader',
  isLoading: true,
  image: null
}

Loading.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  image: PropTypes.string
}
